<template>
  <div class="d-flex fd-column ITEM p-b-2">
    <div
        class="text-bold d-flex jc-between p-2 m-b-1 cur-pointer"
        @click="toggleOpen">
      {{faq.question}}
      <span>
        <vk-icon :name="isOpen ? 'minus' : 'plus'" class="c-depot" />
      </span>
    </div>
    <div v-if="isOpen"><div class="LINE m-l-2 m-b-2 "></div>
    <p v-html="faq.answer" class="p-x-1:mo p-x-2"></p></div>
  </div>
</template>

<script>

export default {
  name: 'faq-item',
  props: {
    faq: {
      type: Object,
      require: true,
    },
  },
  data () {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen;
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.ITEM {
  border: solid 1px $color-gray30;
   text-align: left;
}
.LINE {
  width: 25%;
  border-bottom: solid 2px $color-depot;
}
/deep/ a.FAQ-LINK {
  text-decoration: none;
  color: $color-depot;
}
</style>
